import { Injectable } from "@angular/core";
import { CategoryChoice, ServiceTask, TaskType } from "../model/model";

@Injectable({
    providedIn: "root"
})
export class ServiceTaskService {
    serviceTasks: ServiceTask[] = [];

    constructor() {
        this.serviceTasks.push(new ServiceTask(
            CategoryChoice.TEXT,
            TaskType.FILL_MASK,
            "Completar Máscara",
            "Completa con una palabra un espacio seleccionado dentro de una oración."
        ));
        this.serviceTasks.push(new ServiceTask(
            CategoryChoice.TEXT,
            TaskType.SUMMARY,
            "Resumen",
            "Hace un resumen de un texto dado."
        ));
        this.serviceTasks.push(new ServiceTask(
            CategoryChoice.TEXT,
            TaskType.QNA,
            "Preguntas-respuestas",
            "Infiere una respuesta dado un texto previamente y una pregunta sobre el mismo."
        ));
        this.serviceTasks.push(new ServiceTask(
            CategoryChoice.TEXT,
            TaskType.TEXT_CLASS,
            "Análisis de sentimientos",
            "Ofrece una valoración de cuan positivo o negativo es el texto dado."
        ));
        this.serviceTasks.push(new ServiceTask(
            CategoryChoice.TEXT,
            TaskType.TEXT_GEN,
            "Generación de textos",
            "A partir de una frase incompleta, genera un texto que da continuación a dicha frase."
        ));
        this.serviceTasks.push(new ServiceTask(
            CategoryChoice.TEXT,
            TaskType.TRANSLATION,
            "Traducción",
            "Traduce un texto de Español a Inglés o viceversa."
        ));
        this.serviceTasks.push(new ServiceTask(
            CategoryChoice.TEXT,
            TaskType.TOKEN_CLASS,
            "Reconocimiento de entidades",
            "Reconoce entidades en el texto tales como Persona, Organización, Lugar, Compañías, etc."
        ));
        this.serviceTasks.push(new ServiceTask(
            CategoryChoice.TEXT,
            TaskType.ZERO_SHOT_CLASS,
            "Clasificación dinámica",
            "Clasifica el dominio de un texto a partir de las clases dinámicas definidas por usted."
        ));
        this.serviceTasks.push(new ServiceTask(
            CategoryChoice.IMAGE,
            TaskType.OBJECT_DETECTION,
            "Detección de objetos en imágenes",
            "Detecta objetos cotidianos como pueden ser bicicletas, sombrillas, perros, personas, etc."
        ));
        this.serviceTasks.push(new ServiceTask(
            CategoryChoice.IMAGE,
            TaskType.IMAGE_CLASS,
            "Clasificación de imágenes",
            "Clasifica imágenes por temática asignándole una etiqueta de un conjunto fijo de categorías."
        ));
        this.serviceTasks.push(new ServiceTask(
            CategoryChoice.IMAGE,
            TaskType.SUPER_RESOLUTION,
            "Super resolución de imágenes",
            "Mejora la calidad de las imágenes llevándolas a una resolución mayor."
        ));
        this.serviceTasks.push(new ServiceTask(
            CategoryChoice.IMAGE,
            TaskType.IMAGE_SEGMENTATION,
            "Segmentación de imágenes",
            "Detecta y clasifica diferentes partes de una imagen teniendo en cuenta los objetos y elementos que se encuentran en ella."
        ));
        this.serviceTasks.push(new ServiceTask(
            CategoryChoice.TEXT,
            TaskType.QUESTION_GENERATION,
            "Generación de preguntas",
            "Genera una pregunta que dado un contexto y la respuesta deseada."
        ));
    }

    getAll(): ServiceTask[] {
        return this.serviceTasks;
    }
}
